import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { routerReducer, routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
// import { createLogger } from "redux-logger";
import { reducer as formReducer } from "redux-form";
import thunk from "redux-thunk";
import throttle from "lodash/throttle";
import { reducer as toastrReducer } from "react-redux-toastr";

import { loadState, saveState } from "./utils/sessionStorage";
import rootReducer from "./reducers";
import timeframeReducer from "./reducers/timeframeReducer";
import tagFilterReducer from "./reducers/tagFilterReducer";

// logger middleware
// const logger = createLogger();

// router middleware
export const history = createHistory();
const router = routerMiddleware(history);

// composing middleware
let middleware = [thunk, router];
let composeEnhancers = compose;

if (process.env.REACT_APP_ENV !== "production") {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  middleware = [...middleware];
}
// reducers
const reducers = combineReducers({
  app: rootReducer,
  form: formReducer,
  router: routerReducer,
  toastr: toastrReducer,
  timeframechooser: timeframeReducer,
  tagFilter: tagFilterReducer
});

export const store = createStore(
  reducers,
  {},
  composeEnhancers(applyMiddleware(...middleware))
);

export function configureStore() {
  // let preloadedState = loadState();


  // store.subscribe(
  //   throttle(() => {
  //     let currentState = store.getState();
  //     if (currentState.app.isAuth) {
  //       saveState(currentState);
  //     }
  //   }),
  //   1000
  // );

  // return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js